(() => {
  const widgetSelector = '.jdgm-review-widget';
  const emptySelector = '.jm-review-widget__body .jdgm-empty-state';
  const reviewListSelector = '.jm-review-widget__body .jdgm-review-list';
  const pageOneSelector = 'button[aria-label="Go to page 1"][aria-current="page"]';
  const pageTwoSelector = 'button[aria-label="Go to page 2"]';
  const attemptedAttribute = 'data-jdgm-fallback-page-requested';

  const loadFallbackReviews = () => {
    document.querySelectorAll(widgetSelector).forEach((widget) => {
      if (widget.hasAttribute(attemptedAttribute)) return;
      if (!widget.querySelector(emptySelector)) return;
      if (widget.querySelector(reviewListSelector)) return;

      const pageOne = widget.querySelector(pageOneSelector);
      const pageTwo = widget.querySelector(pageTwoSelector);

      if (!pageOne || !pageTwo || pageTwo.disabled) return;

      widget.setAttribute(attemptedAttribute, 'true');
      pageTwo.click();
    });
  };

  const start = () => {
    loadFallbackReviews();

    const observer = new MutationObserver(loadFallbackReviews);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 20000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', loadFallbackReviews);
})();
